import { render } from "./IconAiAssistant.vue?vue&type=template&id=a6359538&lang=html"
import script from "./IconAiAssistant.vue?vue&type=script&lang=js"
export * from "./IconAiAssistant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__